module.exports = __webpack_public_path__ + "img/option_icon.f40c4252.svg";